import { put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import { config } from "../config/envs";

const INITIAL_STATE = {
  is_cancelling: false,
  customer: {},
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "CANCEL_SUBSCRIPTION":
    return { ...state, is_cancelling: true };
  case "CANCEL_SUBSCRIPTION_SUCCESS":
    return { ...state, is_cancelling: false };
  case "CANCEL_SUBSCRIPTION_FAILED":
    return { ...state, is_cancelling: false };
  case "LOAD_SUBSCRIPTION_CUSTOMER":
    return {
      ...state,
      customer: INITIAL_STATE.customer,
    };
  case "LOAD_SUBSCRIPTION_CUSTOMER_SUCCESS":
    return { ...state, customer: action.payload };
  default:
    return state;
  }
};

function* cancelSubscription({ payload }) {
  try {
    const response = yield axios.post(
      process.env.REACT_APP_API_URL + "/subscription/cancel",
      payload
    );
    if (!response.data.success) {
      yield put({ type: "CANCEL_SUBSCRIPTION_FAILED" });
      return;
    }
    yield put({
      type: "CANCEL_SUBSCRIPTION_SUCCESS",
      payload: response.data.data
    });
    toast.success("Seu plano foi cancelado com sucesso.");
  } catch {
    yield put({ type: "CANCEL_SUBSCRIPTION_FAILED" });
    toast.error(
      "Ocorreu um erro ao cancelar o seu plano, por favor, tente novamente mais tarde."
    );
  }
  payload.callback();
}

function* createSubscription({ payload }) {
  try {
    const route =
      process.env.REACT_APP_API_URL +
      (payload?.values?.migrationFlow
        ? "/subscription/migrate-organic"
        : "/subscription/create");

    const payloadValues = payload?.values?.migrationFlow ? {
      ...payload.values,
      previous_subscription_id: payload.values?.previous_subscription_id,
      card_id: payload.values?.card_hash,
    } : payload.values;
    let response = yield axios.post(
      route,
      payloadValues
    );
    
    if (payload?.values?.migrationFlow) {
      response = {
        data: {
          success: true,
          data: response.data,
          status: "pending_payment"
        }
      };
    }

    if (!response.data.success) {
      toast.error(response.data.msg);
      
      payload.callback(response.data);
      payload.setSubmitting(false);
      return;
    }
    
    const status = response.data?.data?.status;
    if (status === "active") {
      toast.success("Assinatura realizada com sucesso!");
    } else if (status === "failed") {
      toast.error("Falha ao realizar pagamento!");
    }

    payload.callback(response.data);
    payload.setSubmitting(false);
    // yield put({type: 'LOAD_SUBSCRIPTION_STATUS_SUCCESS', payload: response.data.data});
  } catch (err){
    payload.onError(err);
    // yield put({type: 'LOAD_SUBSCRIPTION_STATUS_FAILED'});
    toast.error("Ocorreu um erro, por favor, tente novamente.");
    payload.setSubmitting(false);
  }
}

function* loadSubscriptionCustomer({ payload }) {
  try {
    const response = yield axios.get(
      config.app.adminBaseUrl + "/clients/" + payload.id,
      {}
    );
    yield put({
      type: "LOAD_SUBSCRIPTION_CUSTOMER_SUCCESS",
      payload: {
        ...response.data,
        id: payload.id,
      },
    });
  } catch {}
}

export function* saga() {
  yield takeLatest("CREATE_SUBSCRIPTION", createSubscription);
  yield takeLatest("CANCEL_SUBSCRIPTION", cancelSubscription);
  yield takeLatest("LOAD_SUBSCRIPTION_CUSTOMER", loadSubscriptionCustomer);
}
